import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { AssessmentChallenge } from 'src/types/shared/Assessments';

export const fetchAssessmentChallengesRequest = createAction('fetchAssessmentChallengesRequest');
export const fetchAssessmentChallengesSuccess = createAction<AssessmentChallenge[]>(
    'fetchAssessmentChallengesSuccess',
);
export const fetchAssessmentChallengesFailure = createAction('fetchAssessmentChallengesFailure');

export const fetchAssessmentChallenges = () => async (dispatch: AppDispatch): Promise<void> => {
    dispatch(fetchAssessmentChallengesRequest());
    try {
        const { data }: Response = await api.get('admin/assessments/challenges');

        dispatch(fetchAssessmentChallengesSuccess(data));
    } catch (e) {
        handleApiErrors(dispatch, fetchAssessmentChallengesFailure, e as any);
    }
};

interface Response {
    data: AssessmentChallenge[];
}
